export default __webpack_public_path__ + "static/media/xmeme.5ab1ea07.jpg";